import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { updateFile } from "requesters/uploadsRequester"
import { Modal } from "react-bootstrap"
import { getBaseUrl } from "../../../reducers"

const RenameFileModal = ({
  show, onHide, reloadData, file
}) => {
  const baseUrl = useSelector(getBaseUrl)

  const {
    id,
    attributes: {
      fileNameNoExtention
    }
  } = file.data

  const [newFileName, setNewFileName] = useState(fileNameNoExtention)
  const [validForm, setValidForm] = useState(true)

  const onSubmit = () => {
    if (!newFileName) {
      setValidForm(false)
    } else {
      updateFile(baseUrl, id, { file_name: newFileName })
        .then(result => {
          if (result.error) {
            // eslint-disable-next-line no-console
            console.log(result.error)
            return
          }
          reloadData()
          onHide()
        })
        // eslint-disable-next-line no-console
        .catch(err => console.log(err))
    }
  }

  const showErrorMessage = attributes => {
    if (!validForm && !attributes) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (!show) return
    setNewFileName(fileNameNoExtention)
    setValidForm(true)
  }, [show, fileNameNoExtention])

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title><h2 className="modal-title">Rename File</h2></Modal.Title>
      </Modal.Header>
      <div className="modal-body px-md-5">
        <form>
          <div className="row mb-3">
            <label className="col-4">File Name</label>
            <div className="col-8">
              <input
                className="form-control"
                onChange={e => setNewFileName(e.target.value)}
                value={newFileName} />
              {showErrorMessage(newFileName) && (
                <div className="err-msg">Required Field</div>
              )}
            </div>
          </div>
        </form>
        <div className="modal-footer d-flex justify-content-end p-0 mb-4 mt-5">
          <button
            className="btn btn-link btn-lg"
            onClick={onHide}
            type="submit">
            Close
          </button>
          <button
            className="btn btn-red btn-lg"
            onClick={onSubmit}
            disabled={newFileName === fileNameNoExtention}
            type="submit">
            Save Changes
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default RenameFileModal
